RivalIQ.module('landscape.views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    function showPlanUpsellForListening() {
        const planStripeId = RivalIQ.state.plan.get('stripe_id');

        // This list intentionally omits 2019 and 2023 plans. See #36274
        return _.includes([

            // 2017 plans
            'engage_monthly_15_20171117',
            'engage_monthly_25_20171117',
            'engage_monthly_35_20171117',
            'engage_monthly_45_20171117',
            'engage_monthly_55_20171117',
            'engage_annual_15_20171117',
            'engage_annual_25_20171117',
            'engage_annual_35_20171117',
            'engage_annual_45_20171117',
            'engage_annual_55_20171117',
            'engage_pro_monthly_20_20171117',
            'engage_pro_monthly_30_20171117',
            'engage_pro_monthly_40_20171117',
            'engage_pro_monthly_50_20171117',
            'engage_pro_monthly_60_20171117',
            'engage_pro_annual_20_20171117',
            'engage_pro_annual_30_20171117',
            'engage_pro_annual_40_20171117',
            'engage_pro_annual_50_20171117',
            'engage_pro_annual_60_20171117',

            // 2021 plans
            'drive_monthly_15_20210728',
            'drive_annual_15_20210728',
            'engage_monthly_20_20210728',
            'engage_monthly_25_20210728',
            'engage_monthly_30_20210728',
            'engage_monthly_35_20210728',
            'engage_annual_20_20210728',
            'engage_annual_25_20210728',
            'engage_annual_30_20210728',
            'engage_annual_35_20210728',
            'engage_pro_monthly_40_20210728',
            'engage_pro_monthly_45_20210728',
            'engage_pro_monthly_50_20210728',
            'engage_pro_monthly_55_20210728',
            'engage_pro_annual_40_20210728',
            'engage_pro_annual_45_20210728',
            'engage_pro_annual_50_20210728',
            'engage_pro_annual_55_20210728'
        ], planStripeId);
    }

    const ReviewCompanies = RivalIQ.views.ItemView.mixin({
        template: '#reviewMoreCompaniesModalTemplate',

        initialize: function () {
            const me = this;

            // We used to let customers add 1 or 5 additional companies; now we only allow a 5 pack. This info in the model
            // mimics what the old flow would let the customer configure

            const isAnnualPlan = RivalIQ.state.plan.get('annual');
            const pricePerCompany = isAnnualPlan ? 8.5 : 10; // USD / company
            const fixed = isAnnualPlan ? 2 : 0;

            me.model.set('companyAddOption', {
                companies: 5,
                price: (5 * pricePerCompany).toFixed(fixed),
                plural: true
            });
        },

        beforeNextStep: function () {
            const me = this;

            $.ajax({
                url: '/updatePlan/true',
                type: 'POST',
                success: function (newCompanyCredits) {
                    // If we succeed in automatically upgrading their plan, the new plan details will refresh with the page.
                    // else, update the browser state to reflect new companies added.
                    if (newCompanyCredits) {
                        RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ClickedUpsellLinkSuccess, {
                            page: me.model.get('page')
                        });
                        // landscape add modal stuffs landscape and company limit metadata into landscapeCompanyLimits
                        const landscapeCompanyLimits = RivalIQ.state.account.get('landscapeCompanyLimits');
                        if (landscapeCompanyLimits) {
                            landscapeCompanyLimits.credits = newCompanyCredits;
                            RivalIQ.state.account.set('landscapeCompanyLimits', landscapeCompanyLimits);
                        }
                        RivalIQ.state.account.set('companyLimits', newCompanyCredits);
                    }
                }
            });
        },

        satisfied: _.constant(true),

        serializeData: function () {
            const me = this;

            const companyAddOption = me.model.get('companyAddOption');
            return {
                companiesAdded: companyAddOption.companies,
                price: companyAddOption.price,
                plural: (companyAddOption.companies === 1 ? 'company' : 'companies'),
                subscriptionType: RivalIQ.state.plan.get('annual') ? 'annual' : 'monthly',
                showPlanUpsellForListening: showPlanUpsellForListening()
            };
        },

        onRenderLoaded: function () {
            const me = this;
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ClickedUpsellLinkReview, {
                page: me.model.get('page')
            });
        }
    });

    const addCompaniesSteps = [
        {
            title: 'Confirm Additional Companies',
            stepText: 'Purchase',
            stepClassName: 'btn-primary x-purchase',
            body: ReviewCompanies,
            footerHtml: function (model) {
                if (model.get('page') !== 'subscription' && showPlanUpsellForListening()) {
                    return '<div class="subscription-link"><a href="/manage#subscription">View plans</a> for more companies + social listening.</div>';
                }
            }
        },
        {
            modalClass: 'x-success',
            body: RivalIQ.views.ItemView.extend({
                template: '#companiesAddedSuccessTemplate',

                ui: {
                    returnBtn: '.x-return-btn'
                },

                events: {
                    'click @ui.returnBtn': 'onReturnToPage'
                },

                onReturnToPage: function () {
                    const me = this;

                    RivalIQ.execute('hide:modal');

                    if (me.model.get('showAddCompanyModal')) {
                        RivalIQ.execute('landscape:company:add');
                    } else if (me.model.get('reloadOnSuccess')) {
                        // hack, we serialize the number of companies on the page, so refresh the page so we're showing users all the right info.
                        window.location.reload();
                    }
                },

                serializeData: function () {
                    const me = this;

                    const companiesAdded = me.model.get('companyAddOption').companies;
                    const oldCompanyLimit = RivalIQ.state.account.get('companyLimits').plan;

                    return {
                        oldLimit: oldCompanyLimit,
                        newLimit: companiesAdded + oldCompanyLimit,
                        pageName: me.model.get('showAddCompanyModal') ? 'companies' : 'Your Subscription'
                    };
                }
            })
        }
    ];

    const AddCompaniesModalBody = views.BaseStepModalBody.extend({
        steps: addCompaniesSteps
    });

    const AddCompaniesModal = views.AddCompaniesModal = views.BaseStepModal.extend({
        className: 'modal add-companies-modal fade',
        modalBody: AddCompaniesModalBody,
        onShow: function () {
            const me = this;
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ClickedUpsellLink, {
                page: me.model.get('page')
            });
        }
    });

    views.CompanyAddResults = Marionette.ItemView.extend({
        ui: {
            error: '.x-error',
            added: '.x-we-added',
            content: '.x-content',
            loading: '.x-loading-background-small',
            purchaseCompanies: '.purchase-companies'
        },

        events: {
            'click @ui.purchaseCompanies': 'onPurchaseCompanies'
        },

        modelEvents: {
            change: 'render'
        },
        disableUnfollow: false,
        enableClearButton: false,

        template: '#recommendationViewBlank',
        className: 'company-add-results',

        onPurchaseCompanies: function () {
            RivalIQ.execute('show:modal', new AddCompaniesModal({
                model: new Backbone.Model({
                    showAddCompanyModal: true,
                    credits: RivalIQ.state.account.get('companyLimits'),
                    page: 'company add'
                })
            }));
        },

        templateHelpers: function () {

            const me = this;

            let channelIcon = null;
            let channelName = null;
            const url = me.model.get('url');
            const sourceIdOfUrl = RivalIQ.utils.socialUrl.getUrlChannel(url)?.source;
            if (_.isFinite(sourceIdOfUrl)) {
                channelIcon = RivalIQ.enums.sourceDetails[sourceIdOfUrl].fontIcon;
                channelName = RivalIQ.enums.sourceDetails[sourceIdOfUrl].name;
            }

            return {
                channelIcon: channelIcon,
                channelName: channelName
            };
        },

        initialize: function (options) {

            const me = this;
            const opts = (options || {});
            _.extend(me,
                {
                    options: opts
                },
                _.pick(opts, '$parent', 'parent', 'disableUnfollow', 'pubsub', 'enableClearButton', 'clearButtonText'));
        },
        serializeData: function () {

            const me = this;
            const model = me.model;
            const data = model.toJSON();

            return _.extend(data, {
                name: data.name || '',
                enableClearButton: me.enableClearButton
            });
        },
        getErrorViewConfiguration: function (data) {
            const me = this;

            let templateSelector = null;
            const modelAttributes = {
                domain: _.get(me, 'model.searchData.full_path', data.url)
            };

            const overLimitErrorType = RivalIQ.landscape.enums.overLimitErrorTypes[data.RESTerror.name];
            if (overLimitErrorType) {
                modelAttributes.companyLimits = data.RESTerror.data;
                me.pubsub.trigger('over-limit', {
                    type: overLimitErrorType,
                    data: modelAttributes
                });
                return false;
            }

            if (data.RESTerror.name === 'notDomain') {
                templateSelector = '#addFailureNotDomainTemplate';
            } else if (data.RESTerror.displayString && data.RESTerror.displayString.match(/ENOTFOUND/)) {
                templateSelector = '#addFailureBadAddressTemplate';
            } else if (data.RESTerror.name === 'BadParameterError') {
                templateSelector = '#addFailureBadParamTemplate';
            } else if (data.RESTerror.name === 'Timeout') {
                templateSelector = '#addFailureTimeoutTemplate';
            } else if (data.RESTerror.name === 'TooManyCompaniesError') {
                RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.HitAddCompanyLimit, {
                    show_upsell_link: RivalIQ.state.account.get('accountConversionStatus') === RivalIQ.enums.account.conversionStatus.PAID
                });
                templateSelector = '#addFailureCompanyLimitTemplate';
                _.extend(modelAttributes, _.pick(data.RESTerror.data, 'credits'));
            } else if (data.RESTerror.name === 'TooManyCompaniesAddedInPeriodError') {
                templateSelector = '#addFailureCompanySwapLimitTemplate';
                _.extend(modelAttributes, _.pick(data.RESTerror.data, 'credits'));
            } else if (data.RESTerror.name === 'InvalidHandleError') {
                templateSelector = '#suggestionModalInvalidHandle';
                _.extend(modelAttributes, data.RESTerror.data);

                modelAttributes.isInstagram = (modelAttributes.channel === RivalIQ.enums.channels.INSTAGRAM);
                modelAttributes.isYoutube = (modelAttributes.channel === RivalIQ.enums.channels.YOUTUBE);
                modelAttributes.isFacebook = (modelAttributes.channel === RivalIQ.enums.channels.FACEBOOK);
                modelAttributes.facebookOauthUrl = RivalIQ.channels.getOAuthUrl(RivalIQ.enums.sources.FACEBOOK);
            } else {
                templateSelector = '#addFailureGenericTemplate';
            }

            return {
                template: templateSelector,
                model: new Backbone.Model(modelAttributes)
            };
        },
        onRender: function () {

            const me = this;
            const ui = me.ui;
            const data = me.model.toJSON();

            if (data.RESTerror) {

                const viewConfig = _.defaults({
                    el: me.$('.x-add-alert'),
                    templateHelpers: function () {
                        return {
                            formatLabeledNumber: RivalIQ.formatter.formatLabeledNumber
                        };
                    }
                }, me.getErrorViewConfiguration(data));

                ui.loading.hide();
                ui.content.hide();
                ui.added.empty('');

                if (viewConfig) {

                    ui.error.show();
                    new Marionette.ItemView(viewConfig).render();
                }

                return;
            }

            if (data.id && data.periodSummary) {

                const view = new views.CompanyAddResult({
                    data: data,
                    pubsub: me.pubsub,
                    disableUnfollow: me.disableUnfollow,
                    enableFollow: Boolean(Marionette.getOption(me, 'enableFollow')),
                    enableClearButton: me.enableClearButton,
                    clearButtonText: me.clearButtonText
                });

                me.listenTo(view, 'unfollow', _.bind(me.onCompanyUnfollowed, me, view));

                me.trigger('companyfollowed');

                ui.content.html('');
                ui.error.hide();

                if (me.getOption('useFadeInAnimation')) {
                    if (me.ui.loading.is(':visible')) {
                        ui.loading.velocity('fadeOut', {
                            duration: 150,
                            complete: function () {
                                ui.content.hide()
                                    .append(view.render().el)
                                    .velocity('fadeIn', {
                                        duration: 500
                                    });
                            }
                        });
                    } else {
                        // if the data came back before we even showed the loading spinner, we can skip
                        // fading it out and just show the content.
                        ui.content.hide()
                            .append(view.render().el)
                            .velocity('fadeIn', {
                                duration: 500
                            });
                    }
                } else {
                    ui.loading.velocity('fadeOut', {
                        duration: 500,
                        complete: function () {

                            ui.added.velocity('fadeIn', {
                                delay: 50,
                                duration: 500
                            });

                            ui.content.hide()
                                .append(view.render().el)
                                .velocity('slideDown', {
                                    delay: 550,
                                    duration: 500
                                });
                        }
                    });
                }
            } else {

                ui.loading.hide();
                ui.content.hide();
                ui.added.hide();
            }
        },
        clearWithNoLoading: function () {

            const me = this;
            const ui = me.ui;

            ui.content.hide();
            ui.error.hide();
            ui.added.hide();
            ui.loading.hide();
        },
        clearAndShowLoading: function () {

            const me = this;
            const ui = me.ui;

            ui.content.hide();
            ui.error.hide();
            ui.added.hide();
            ui.loading.show();
        },
        onCompanyUnfollowed: function (view, data) {

            const me = this;

            if (data.id === App.state.utils.getFocusedCompanyId()) {

                return me.onUnfollowCompleted(view, data, false);
            }

            App.execute('landscape:company:remove', data.id,
                _.bind(me.onUnfollowCompleted, me, view, data, true));
        },
        onUnfollowCompleted: function (view, data, shouldDisplay) {

            const me = this;
            const $el = view.$el;
            const autoFollow = Marionette.getOption(me, 'autoFollow');

            me.ui.added.velocity('fadeOut', {
                duration: 500
            });

            $el.velocity('fadeOut', {
                duration: 500,
                complete: function () {

                    // NOTE calling destroy makes sure that the view is turned
                    // down appropriately (e.g., managed listeners are removed)
                    view.destroy();

                    if (shouldDisplay === false) {

                        me.$('.x-we-added span').html('');
                    } else {

                        me.$('.x-we-added span').html((autoFollow !== false ?
                            `${data.name} removed from landscape.` : ''));
                    }

                    me.$('img.x-check').hide();

                    me.ui.added.velocity('fadeIn', {
                        duration: 500
                    });
                    $('input.x-domain-input').focus();

                    me.trigger('companyunfollowed');
                    me.pubsub.trigger('company-add-removed', data);
                }
            });
        }
    });

});
